import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import { useData } from '../../context/DataContext';
import Loading from '../Loading/Loading';
import MaterialReactTableWithSearch from '../MaterialTable/MaterialReactTableWithSearch';

function Subscriptions() {
    const { subscribersData, loading, error, todaySubscriptions } = useData();
    const [activeFilter, setActiveFilter] = useState('total');

    if (loading) return <Loading />;
    if (error) return <div style={{ padding: 24, color: 'red' }}>Error: {error}</div>;
    if (!subscribersData) return <div style={{ padding: 24 }}>No subscriber data available.</div>;

    const columns = [
        { accessorFn: (row, index) => index + 1, header: 'SNO', id: 'id', size: 60 },
        { accessorKey: 'email', header: 'Email' },
        {
            accessorKey: 'inserted_time',
            header: 'Subscribed Date',
            Cell: ({ cell }) => {
                const d = new Date(cell.getValue());
                return <span>{d.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '')}</span>;
            },
        },
    ];

    const activeData = activeFilter === 'total' ? subscribersData : todaySubscriptions;

    return (
        <Container fluid className="px-0">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Subscriptions</h1>
                    <p className="page-subtitle">{subscribersData.length} subscribers total</p>
                </div>
            </div>

            <div className="filter-bar">
                <button
                    className={`btn-filter ${activeFilter === 'total' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('total')}
                >
                    All Subscribers
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{subscribersData.length}</span>
                </button>
                <button
                    className={`btn-filter ${activeFilter === 'today' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('today')}
                >
                    Today
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{todaySubscriptions.length}</span>
                </button>
            </div>

            <div className="table-container">
                <MaterialReactTableWithSearch columns={columns} data={activeData} />
            </div>
        </Container>
    );
}

export default Subscriptions;
